<template>
    <div class="flex flex-col items-center">
        A Generic True-False Question

        <div class="flex my-4">
            <button class="mx-2" @click="answer(true)">
                Answer True
            </button>

            <button class="mx-2" @click="answer(false)">
                Answer False
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        question: {},
    },

    methods: {
        answer(value) {
            this.$emit('answered', value);
        }
    },
}
</script>
